import React from 'react'
import {Radio, ParagraphText} from '@thryvlabs/maverick'

const VerticalServicePaymentQuestion = ({
  selectedOption,
  setSelectedOption,
  disabled = false,
}) => {
  const options = [
    {value: 'oneTime', label: 'All at Once'},
    {value: '6Monthly', label: 'Over 6 Invoices'},
  ]

  return (
    <div className="mb-4">
      <ParagraphText
        variant="lg"
        style={{
          fontWeight: 'bold',
          fontSize: '14px',
          marginBottom: '12px',
        }}
      >
        How would you like to pay your vertical service fees?
        <span style={{color: '#e74c3c'}}>*</span>
      </ParagraphText>

      <div
        style={{
          display: 'flex',
          gap: '24px',
          padding: '16px',
          border: '1px solid #e0e0e0',
          borderRadius: '8px',
        }}
      >
        {options.map(option => (
          <label
            key={option.value}
            style={{
              display: 'flex',
              alignItems: 'center',
              cursor: disabled ? 'not-allowed' : 'pointer',
            }}
          >
            <Radio
              toggled={selectedOption === option.value}
              disabled={disabled}
              onChange={() => setSelectedOption(option.value)}
            />
            <span style={{marginLeft: '8px'}}>{option.label}</span>
          </label>
        ))}
      </div>
    </div>
  )
}

export default VerticalServicePaymentQuestion
